<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>

    <div class="writeGridContainer ">
      <div>
        <div>대표자(안전보건관리책임자)</div>
        <p v-if="isPrint" class="print-input">{{ form.대표자 }}</p>
        <ml-input v-else v-model="form.대표자" />
      </div>
      <div>
        <div>소재지</div>
        <p v-if="isPrint" class="print-input">{{ form.소재지 }}</p>
        <ml-input v-else v-model="form.소재지" />
      </div>
      <div>
        <div>법인등록번호<br/>(사업자등록번호)</div>
        <p v-if="isPrint" class="print-input">{{ form.사업자등록번호 }}</p>
        <ml-input v-else v-model="form.사업자등록번호" />
      </div>

      <div>
        <div>업종</div>
        <p v-if="isPrint" class="print-input">{{ form.업종 }}</p>
        <ml-input v-else v-model="form.업종" />
      </div>
      <div>
        <div>근로자수</div>
        <p v-if="isPrint" class="print-input">{{ form.근로자수 }}</p>
        <ml-input v-else v-model="form.근로자수" />
      </div>
      <div>
        <div>전화번호<br/>(팩스번호)</div>
        <p v-if="isPrint" class="print-input">{{ form.전화번호 }}</p>
        <ml-input v-else v-model="form.전화번호" />
      </div>

      <div class="writeGridLineItem">
        <div>생산품목</div>
        <p v-if="isPrint" class="print-input">{{ form.생산품목 }}</p>
        <ml-input v-else v-model="form.생산품목" />
      </div>
    </div>

    <!--    작업구분-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 작업구분
        </h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-6 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center"
           v-for="(check, index) in inspectionCheckList"
           :key="`inspectionCheckList_${index}`">
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form[`check_${check.value}`]"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ check.label }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :disabled="board.readonly"
              v-model="form[`check_${check.value}`]"
            ></vs-checkbox>
            {{ check.label }}
          </span>
        </div>
      </div>
    </div>

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>

    <!--    점검정보 : 기존에 stdinfo에서 사용했던 정보 (24.12.12) -->
    <div class="mt-8">
      <h5><i class="dot"></i> 점검정보</h5>
      <div class="writeGridContainer mt-4">
        <div>
          <div>점검일</div>
          <p v-if="isPrint" class="print-input">{{ form.stdInfo.점검일 }}</p>
          <date-selector v-model="form.stdInfo.점검일" v-else />
        </div>
        <div>
          <div>점검장소</div>
          <p v-if="isPrint" class="print-input">{{ form.stdInfo.점검장소}}</p>
          <ml-input v-else v-model="form.stdInfo.점검장소" />
        </div>
        <div>
          <div>재해형태</div>
          <p v-if="isPrint" class="print-input">{{ form.stdInfo.재해형태 }}</p>
          <disaster-class-selector v-else v-model="form.stdInfo.재해형태" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <table-inspect-merge
      v-for="(check, index) in inspectionCheckList"
      :key="`inspect_${index}`"
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="check.label"
      v-model="form[`inspectList${check.value}_convert`]"
      v-if="form[`check_${check.value}`] && index !== 2"
      :content-before-numbering="index > 0"
    />

    <div v-show="form.check_3" class="mt-5">
      <h5><i class="dot"></i> {{ inspectionCheckList[2].label }}</h5>
      <table class="mt-4">
        <colgroup>
          <col />
          <col width="82" />
          <col width="82" />
          <col width="82" />
          <col width="300" />
        </colgroup>
        <thead>
        <tr>
          <th rowspan="2">점검항목</th>
          <th colspan="3">점검결과</th>
          <th rowspan="2">증빙자료</th>
        </tr>
        <tr>
          <th>양호</th>
          <th>미흡</th>
          <th>해당없음</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(item, index) in form.inspectList4_convert" >
          <tr v-if="index === 0 || item.title !== form.inspectList4_convert[index - 1].title" :key="`inspectList4_convert_title_${index}`">
            <th colspan="5">{{ item.title }}</th>
          </tr>
          <tr :key="`inspectList4_convert_${index}`">
            <td>
              <div class="flex">
                <span class="mr-2">·</span>
                <span v-html="item.content" />
              </div>
            </td>
            <td>
              <radio-type-check
                :name="`점검결과_${index}`"
                checkValue="양호"
                :readonly="isPrint || item.readonly || board.readonly" v-model="item.isChecked"
              />
            </td>
            <td>
              <radio-type-check
                :name="`점검결과_${index}`"
                checkValue="미흡"
                :readonly="isPrint || item.readonly || board.readonly" v-model="item.isChecked"
              />
            </td>
            <td>
              <radio-type-check
                :name="`점검결과_${index}`"
                checkValue="해당없음"
                :readonly="isPrint || item.readonly || board.readonly" v-model="item.isChecked"
              />
            </td>
            <td>
              <p v-if="isPrint">{{ item.증빙자료? item.증빙자료.fileName: '' }}</p>
              <FileUploader
                v-else
                v-model="item.증빙자료"
                :readonly="item.readonly || board.readonly"
              />
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

    <div v-show="form.check_5"  class="mt-5">
      <h5><i class="dot"></i> 한랭 작업</h5>
      <table class="mt-4">
        <tbody>
        <tr>
          <th class="text-center">건설현장명</th>
          <td colspan="4">
            <p v-if="isPrint" class="print-input">{{ form.info_5.건설현장명 }}</p>
            <ml-input v-else class="w-full h-full" v-model="form.info_5.건설현장명"/>
          </td>
        </tr>
        <tr>
          <th class="text-center">현장소재지</th>
          <td colspan="4">
            <p v-if="isPrint" class="print-input">{{ form.info_5.현장소재지 }}</p>
            <ml-input v-else class="w-full h-full" v-model="form.info_5.현장소재지"/>
          </td>
        </tr>
        <tr>
          <th class="text-center">공사규모<br>(단위: 억)</th>
          <th class="text-center">시공사</th>
          <th class="text-center">휴게시설 설치여부</th>
          <th class="text-center">휴게시설 관리기준<br>준수 여부</th>
          <th class="text-center">개선계획</th>
        </tr>
        <tr>
          <td>
            <p v-if="isPrint" class="print-input">{{ form.info_5.공사규모 }}</p>
            <ml-input v-else class="w-full h-full" v-model="form.info_5.공사규모"/>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ form.info_5.시공사 }}</p>
            <ml-input v-else class="w-full h-full" v-model="form.info_5.시공사"/>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ form.info_5.휴게시설설치여부 }}</p>
            <ml-input v-else class="w-full h-full" v-model="form.info_5.휴게시설설치여부"/>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ form.info_5.휴게시설관리기준준수여부 }}</p>
            <ml-input v-else class="w-full h-full" v-model="form.info_5.휴게시설관리기준준수여부"/>
          </td>
          <td>
            <p v-if="isPrint" class="print-input">{{ form.info_5.개선계획 }}</p>
            <ml-input v-else class="w-full h-full" v-model="form.info_5.개선계획"/>
          </td>
        </tr>
        </tbody>
      </table>
      <table class="mt-4">
        <colgroup>
          <col width="400" />
          <col width="82" />
          <col width="82" />
        </colgroup>
        <thead>
        <tr>
          <th rowspan="2">점검항목</th>
          <th colspan="2">점검결과</th>
        </tr>
        <tr>
          <th>적정</th>
          <th>개선 필요</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(item, index) in form.inspectList_5" >
          <tr v-if="index === 0 || item.title !== form.inspectList_5[index - 1].title" :key="`inspectList_5_title_${index}`">
            <th colspan="5">{{ item.title }}</th>
          </tr>
          <tr>
            <td>
              <div class="flex">
                <span class="mr-2">·</span>
                <span v-html="item.content" />
              </div>
            </td>
            <td>
              <radio-type-check
                :name="`점검결과_${index}`"
                checkValue="적정"
                :readonly="isPrint || item.readonly || board.readonly"
                v-model="item.isChecked"
              />
            </td>
            <td>
              <radio-type-check
                :name="`점검결과_${index}`"
                checkValue="개선필요"
                :readonly="isPrint || item.readonly || board.readonly"
                v-model="item.isChecked"
              />
            </td>
          </tr>
        </template>
        </tbody>
      </table>

    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!-- 점검자 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 점검자</h5>
      </div>
      <name-with-signature-row label-name="사업주(또는 현장책임자)" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="참여자(명예감독관 또는 노동자 대표 등 참여)" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="참여자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
    </div>

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableEquipment from '@/components/TableEquipment'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "./inspectData";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    TableInspectMerge,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        // self-emit echo (parent.value === this.form)는 무시 → 무한 루프 차단
        if (value === this.form) return;

        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        if (this.form.inspectList_2 && this.form.inspectList_2.length !== 0 &&
          (!this.form.inspectList2_convert || this.form.inspectList2_convert.length === 0)) {
          this.form.inspectList2_convert = this.form.inspectList_2.map(item => {
            return {
              id: item.id,
              content: item.label,
              isChecked:
                item.is_checked === 'Yes' ? '양호'
                  : item.is_checked === 'No' ? '미흡'
                    : item.is_checked === 'N/A' ? '해당없음' : ''
            };
          });
        }

        if (this.form.inspectList_3 && this.form.inspectList_3.length !== 0 &&
          (!this.form.inspectList3_convert || this.form.inspectList3_convert.length === 0)) {
          this.form.inspectList3_convert = this.form.inspectList_3.map(item => {
            return {
              id: item.id,
              content: item.label,
              isChecked:
                item.is_checked === 'Yes' ? '양호'
                  : item.is_checked === 'No' ? '미흡'
                    : item.is_checked === 'N/A' ? '해당없음' : ''
            };
          });
        }

        // 기존문서 inspectData 중복 제거
        if (this.form.inspectList4_convert.length === 9) {
          if (this.form.inspectList4_convert[6].content === '한파 특보 시 적정한 휴식시간을 제공하고 있는가?'
            && this.form.inspectList4_convert[7].content === '한파 특보 시 적정한 휴식시간을 제공하고 있는가?') {
            this.form.inspectList4_convert.splice(7, 1)
          }
        }

        // 외부 데이터가 들어올 때마다 머지 → 최신 템플릿 문구 적용 (오타 수정 / 항목 추가 반영)
        if (Array.isArray(this.form.inspectList1_convert) && this.form.inspectList1_convert.length > 0) {
          this.form.inspectList1_convert = this.mergeInspectList(inspectData.inspectTable_1, this.form.inspectList1_convert)
        }
        if (Array.isArray(this.form.inspectList2_convert) && this.form.inspectList2_convert.length > 0) {
          this.form.inspectList2_convert = this.mergeInspectList(inspectData.inspectTable_2, this.form.inspectList2_convert)
        }
        if (Array.isArray(this.form.inspectList3_convert) && this.form.inspectList3_convert.length > 0) {
          this.form.inspectList3_convert = this.mergeInspectList(inspectData.inspectTable_3, this.form.inspectList3_convert)
        }
        if (Array.isArray(this.form.inspectList4_convert) && this.form.inspectList4_convert.length > 0) {
          this.form.inspectList4_convert = this.mergeInspectList(inspectData.inspectTable_4, this.form.inspectList4_convert, ['증빙자료', 'readonly'])
        }
        if (Array.isArray(this.form.inspectList_5) && this.form.inspectList_5.length > 0) {
          this.form.inspectList_5 = this.mergeInspectList(inspectData.inspectTable_5, this.form.inspectList_5, ['readonly'])
        }

        if (this.form.check_3) {
          this.inspectionCheckList = [
            { label: '폭염 작업', value: '1' },
            { label: '풍수해 작업', value: '2' },
            { label: '한랭 작업', value: '3' },
          ]
        } else {
          this.inspectionCheckList = [
            { label: '폭염 작업', value: '1' },
            { label: '풍수해 작업', value: '2' },
            { label: '한랭 작업', value: '5' },
          ]
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      inspectionCheckList: [
        { label: '폭염 작업', value: '1' },
        { label: '풍수해 작업', value: '2' },
        { label: '한랭 작업', value: '3' },
        { label: '한랭 작업', value: '5' },
      ],

      form: {
        stdInfo: { },
        photoList: [],

        check_1: false,
        check_2: false,
        check_3: false, // 기존 한랭작업, 기존 데이터를 유지하기 위해 남겨둠
        check_5: false, // 신규 한랭작업
        fileList: [],
        equipmentList: [],
        inspectList_1: [],
        inspectList_2: [],
        inspectList_3: [],

        inspectList1_convert: inspectData.inspectTable_1,
        inspectList2_convert: inspectData.inspectTable_2,
        inspectList3_convert: inspectData.inspectTable_3,
        inspectList4_convert: inspectData.inspectTable_4,
        inspectList_5: inspectData.inspectTable_5,

        info_5: {
          건설현장명: "",
          현장소재지: "",
          공사규모: "",
          시공사: "",
          휴게시설설치여부: "",
          휴게시설관리기준준수여부: "",
          개선계획: ""
        },

        대표자: "",
        소재지: "",
        사업자등록번호: "",
        업종: "",
        근로자수: "",
        전화번호: "",
        생산품목: "",

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
      },
    }
  },
  computed: {
    inspectTable_1 () {
      return [
        {
          id: 1,
          label: '우리 사업장에서 열원이 발생하거나 열원을 취급하는지에 대해 분류･파악하고 있는가?',
          is_checked: ''
        },
        {
          id: 2,
          label: '우리 사업장에서 고열의 유해성･위험성 및 관리방안을 근로자에게 주지 시키고 있는가?',
          is_checked: ''
        },
        {
          id: 3,
          label: '작업환경측정 등을 통해 근로자에게 노출되는 고열 노출수준을 관리하고 있는가?',
          is_checked: ''
        },
        {
          id: 4,
          label: '측정결과에 따라 적정한 열원 등의 적정한 관리방안을 마련하고 있는가?',
          is_checked: ''
        },
        {
          id: 5,
          label: '근로자를 배치하기 전 근로자의 건강상태와 특성 등을 고려하여 배치 하고 있는가?',
          is_checked: ''
        },
        {
          id: 6,
          label: '열원의 격리와 작업장 내 온･습도 조절을 위한 냉방장치 등이 설치되어 있는가?',
          is_checked: ''
        },
        {
          id: 7,
          label: '작업의 강도에 따른 휴식시간을 적절히 부여하고, 쾌적한 휴게공간을 제공하고 있는가?',
          is_checked: ''
        },
        {
          id: 8,
          label: '비상시 온도를 낮추거나 열을 차단할 수 있는 냉각시스템이 구축되어 있는가?',
          is_checked: ''
        },
        {
          id: 9,
          label: '근로자들이 휴식시간에 이용할 수 있는 휴게시설을 갖추고 있는가?',
          is_checked: ''
        },
        {
          id: 10,
          label: '다량의 고열물체를 취급하는 장소 등에 관계 근로자 외 출입을 금지하고 그 내용을 게시하고 있는가?',
          is_checked: ''
        },
      ]
    },
    inspectTable_2 () {
      return [
        {
          id: 1,
          label: '풍수해 대비 비상매뉴얼은 작성하는가?',
          is_checked: ''
        },
        {
          id: 2,
          label: '매뉴얼에 따른 업무분장이 적합한가?',
          is_checked: ''
        },
        {
          id: 3,
          label: '사전 비상대비 훈련을 실시하는가?',
          is_checked: ''
        },
        {
          id: 4,
          label: '예상 강우량에 따라 우수 유입량은 계산하는가?',
          is_checked: ''
        },
        {
          id: 5,
          label: '현장 구간 내 시설물에 대한 우수 등의 유입에 대한 안전성평가가 이루어지는가?',
          is_checked: ''
        },
        {
          id: 6,
          label: '배수계획도는 작성되었는가?',
          is_checked: ''
        },
        {
          id: 7,
          label: '수방자재는 확보되었는가?\n' +
            '※ 양수기(고장 시 대비 여유분 포함), 마대, 가마니, 삽, 리어카, 우비, 장화, 렌턴 등',
          is_checked: ''
        },
        {
          id: 8,
          label: '비상대기반을 편성하였는가?',
          is_checked: ''
        },
        {
          id: 9,
          label: '작업중지 명령 체계가 확립되었는가?',
          is_checked: ''
        },
        {
          id: 10,
          label: '발주처 및 원하청 간 비상 연락망은 구축되었으며 실제 운영하는가?',
          is_checked: ''
        },
        {
          id: 11,
          label: '비상사태 발생 시 이에 대한 대책 수립을 하는가?\n' +
            '※ 집중호우 시 자재 및 장비 대피 계획 등',
          is_checked: ''
        },
      ]
    },
    inspectTable_3 () {
      return [
        {
          id: 1,
          label: '우리 사업장에서 한랭작업이 발생하거나 취급하는지에 대해 분류･파악하고 있는가?',
          is_checked: ''
        },
        {
          id: 2,
          label: '우리 사업장에서 한랭의 유해성･위험성 및 관리방안을 근로자에게 주지시키고 있는가?',
          is_checked: ''
        },
        {
          id: 3,
          label: '작업환경측정 등을 통해 근로자에게 노출되는 한랭 노출수준을 관리하고 있는가?',
          is_checked: ''
        },
        {
          id: 4,
          label: '측정결과에 따라 적정한 열원 등의 적정한 관리방안을 마련하고 있는가?',
          is_checked: ''
        },
        {
          id: 5,
          label: '근로자를 배치하기 전 근로자의 건강상태와 특성 등을 고려하여 배치하고 있는가?',
          is_checked: ''
        },
        {
          id: 6,
          label: '저온환경의 격리와 작업장 내 온･습도 조절을 위한 난방장치 등이 설치되어 있는가?',
          is_checked: ''
        },
        {
          id: 7,
          label: '작업의 강도에 따른 휴식시간을 적절히 부여하고, 쾌적한 휴게공간을 제공하고 있는가?',
          is_checked: ''
        },
        {
          id: 8,
          label: '비상시 온도를 낮추거나 열을 차단할 수 있는 난방시스템이 구축되어 있는가?',
          is_checked: ''
        },
        {
          id: 9,
          label: '근로자들이 휴식시간에 이용할 수 있는 휴게시설을 갖추고 있는가?',
          is_checked: ''
        },
        {
          id: 10,
          label: '다량의 저온물체를 취급하는 장소 등에 관계근로자 외 출입을 금지하고 그 내용을 게시하고 있는가?',
          is_checked: ''
        },
      ]
    },
  },
  methods : {
    updateList (list) {
      this.form.equipmentList = list
    },
    updateListCheck_1 (indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text
    },
    updateListCheck_2 (indexRows, text) {
      this.form.inspectList_2[indexRows].is_checked = text
    },
    updateListCheck_3 (indexRows, text) {
      this.form.inspectList_3[indexRows].is_checked = text
    },
    mergeInspectList (template, saved, extraFields = []) {
      if (!Array.isArray(saved) || saved.length === 0) {
        return JSON.parse(JSON.stringify(template));
      }
      const savedHasKeys = saved.some(item => item && item.key);
      return template.map((row, i) => {
        const savedRow = savedHasKeys
          ? saved.find(s => s && s.key === row.key)
          : saved[i];
        if (!savedRow) {
          return JSON.parse(JSON.stringify(row));
        }
        // 템플릿 row를 기반(deep clone)으로 시작 → title/content 등 모든 구조 필드가 항상 최신
        // 사용자 입력값(isChecked, is_checked, note 등)만 saved에서 덮어쓰기
        const merged = JSON.parse(JSON.stringify(row));
        if (savedRow.isChecked !== undefined) merged.isChecked = savedRow.isChecked;
        if (savedRow.is_checked !== undefined) merged.is_checked = savedRow.is_checked;
        if (savedRow.note !== undefined) merged.note = savedRow.note;
        for (const field of extraFields) {
          if (savedRow[field] !== undefined) merged[field] = savedRow[field];
        }
        return merged;
      });
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$header-color: #f9f9f9;
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;

  thead {
    th {
      padding: 10px;
      border: $border;
      background-color: $header-color;
      text-align: center;
      font-weight: 500;
      font-size: 14px;
    }
  }

  tbody {
    th {
      padding: 14px 10px;
      background-color: $header-color;
      font-weight: 700;
    }

    td {
      padding: 14px 10px;
      font-weight: 500;
    }

    th, td {
      border: $border;
      font-size: 14px;
    }
  }
}
</style>
